import styled from "styled-components"
import CloudinaryImage from "components/cloudinary-image"
import minWidth from "utils/minWidth"

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
`

export const CardContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.background.primary || "#fff"};
  border-radius: 0;
`

export const ImageWrapper = styled.div`
  height: 20rem;
  width: 100%;
`

export const CardImage = styled(CloudinaryImage)`
  padding-bottom: calc(169 / 169 * 100%);

  ${minWidth.tablet`
    padding-bottom: calc(220 / 220 * 100%);
  `}
`

export const Category = styled.p`
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.6rem;
  letter-spacing: 0.2rem;
  text-align: left;
  color: ${({ theme }) => theme.colors.primaryOrange};
  text-transform: uppercase;
  margin: 4.5rem auto 1rem;

  ${minWidth.desktop`
    margin: 2rem auto 1rem;
  `}
`

export const Headline = styled.h3`
  font-size: 2.4rem;
  font-weight: 400;
  line-height: 3.2rem;
  letter-spacing: 0em;
  text-align: left;
`

export const Subheadline = styled.p`
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 2.5rem;
  letter-spacing: 0em;
  text-align: left;
  height: 7rem;
`

export const ButtonElement = styled.input`
  margin: 0;
  width: 100%;
  height: 3.5rem;
  background-color: ${({ theme }) => theme.colors.primaryOrange};
  border-radius: 2rem;
  border: none;
  color: white;
  font-size: 1.4rem;
  font-weight: 500;
  cursor: pointer;
`
export const ButtonText = styled.p`
  color: white;
  font-size: 1.4rem;
  font-weight: 500;
  margin: 0.5rem;
`
